import moduleTemplate from './moduleTemplate'
import carsAPI from '@/api/cars'

const types = {
  selectCar: 'selectCar',
  addTrack: 'addTrack',
  loadTrack: 'loadTrack',
  addToTrackOfSelected: 'addToTrackOfSelected',
  clearTrackOfSelected: 'clearTrackOfSelected',
  clearTrack: 'clearTrack'
}

const template = moduleTemplate(carsAPI)

template.state = {
  ...template.state,
  selectedCar: undefined,
  track: [],
  selectedTrack: [],
  lastSelectedId: null
}

template.state.expandAllItems = ['lastState']

template.getters = {
  getSelected: state => {
    return state.selectedCar
  }
}

template.mutations = {
  ...template.mutations,
  [template.types.loadItems] (state, {
    items,
    page,
    pageCount,
    pageSize,
    totalCount
  }) {
    state.items = items
    // записать обновленную позицию
    if (state.selectedCar) {
      const point = state.items.find(car => car.id === state.selectedCar.id)
      const peekedPoint = state.selectedTrack[0]
      if (point &&
        point.lastState.lat.value &&
        point.lastState.lng.value &&
        peekedPoint &&
        point.lastState.lat.value != peekedPoint[0] &&
        point.lastState.lng.value != peekedPoint[0]
      ) {
        state.selectedTrack.push([point.lastState.lat.value, point.lastState.lng.value])
      }
    }
    state.page = page
    state.pageCount = pageCount
    state.pageSize = pageSize
    state.totalCount = totalCount
  },
  [types.addTrack] (state, { track }) {
    if (state.selectedCar) {
      track.reverse().forEach(trackPoint => {
        const peekedPoint = state.selectedTrack[0]
        if (trackPoint &&
          trackPoint[0] &&
          trackPoint[1] &&
          peekedPoint &&
          trackPoint[0] != peekedPoint[0] &&
          trackPoint[1] != peekedPoint[0]
        ) {
          state.selectedTrack.unshift([trackPoint[0].toString(), trackPoint[1].toString()])
        }
      })
    }
  },
  [types.selectCar] (state, value) {
    // Пересоздать объект при выборе того же автомобиля (для обновления)
    if (state.selectedCar === value) {
      state.selectedCar = { ...state.selectedCar, ...value }
    } else {
      state.selectedCar = value
    }

    // сохранить последний выбранный автомобиль
    if (state.selectedCar) {
      state.lastSelectedId = state.selectedCar.id
    }

    if (value && value.lastState.lat.value) {
      state.selectedTrack.push([value.lastState.lat.value, value.lastState.lng.value])
    }
  },
  [types.loadTrack] (state, { track }) {
    state.track = track
  },
  [types.clearTrackOfSelected] (state) {
    state.selectedTrack = []
  },
  [types.clearTrack] (state) {
    state.track = []
  }
}

template.actions = {
  ...template.actions,
  selectCar ({ commit, state }, id) {
    if (id) {
      commit(types.clearTrackOfSelected)
    }
    commit(types.selectCar, state.items.find(car => car.id === id))
  },
  getTrack ({ commit, dispatch }, { id, sTime, eTime }) {
    return carsAPI.getTrack(id, sTime, eTime)
      .promise
      .then(track => {
        commit(types.loadTrack, track)
        return track
      })
  },
  getStartTrack ({ commit, state }, { id, startTimeOfTrack, endTimeOfTrack }) {
    return carsAPI.getTrack(id, startTimeOfTrack, endTimeOfTrack)
      .promise
      .then(track => {
        if (id) {
          commit(types.clearTrackOfSelected)
        }
        commit(types.selectCar, state.items.find(car => car.id === id))
        commit(types.addTrack, track)
      })
  },
  clearTrack ({ commit }) {
    commit(types.clearTrackOfSelected)
    commit(types.clearTrack)
  }
}

export default template
